import config from '@/config'
import { useGeoIpLocation } from './use-geo-ip-location'
const isDev = config.BUILD_ENV === 'dev'

const CITIES: Record<string, string[]> = {
  CA: ['Winnipeg', 'Halifax', 'Victoria', 'London', 'Ottawa', 'Chilliwack'],
  US: ['Seattle']
}
const DEV_CITIES = ['Vancouver', 'Richmond']

const useZendesk = () => {
  const userLocation = useGeoIpLocation()
  const country = userLocation.country_code_alpha2
  const city = userLocation.city
  const userCities = CITIES[country] || []
  const zendeskCities = isDev ? [...userCities, ...DEV_CITIES] : userCities

  return zendeskCities.includes(city)
}

export default useZendesk
